module.exports = __webpack_public_path__ + "static/Q6Answer_Donoteat_wishmastree-7ca9ecf1ecb6a894b3fe0e98336ed78d.jpg";